module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "option-list"
  }, _vm._l((_vm.value), function(option) {
    return _c('li', {
      staticClass: "option"
    }, [(option.href) ? _c('router-link', {
      staticClass: "option-inner",
      attrs: {
        "to": option.href
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getText(option)) + "\n    ")]) : _c('div', {
      staticClass: "option-inner"
    }, [_vm._v("\n      " + _vm._s(_vm.getText(option)) + "\n    ")])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6684db42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/option-list/index.vue
// module id = 2061
// module chunks = 2